import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./LibraryLessonCardNumber.module.scss";
import {isUndefined} from "../../../util/is-type";

export interface ILibraryLessonCardNumberProps {
  value?: number | string;
}

export const LibraryLessonCardNumber: VoidFunctionComponent<ILibraryLessonCardNumberProps> = ({value}) => {
  if (isUndefined<number | string>(value)) {
    return null;
  }
  return <div className={s.cardNumber}>{value}</div>;
}

